import UserAlertsRepository from './UserAlertsRepository.js'

/**
 * @class
 * @implements EmptyUserAlertsRepository
 */

class EmptyUserAlertsRepository extends UserAlertsRepository {
  constructor({unseenSavedSearchMatchesValueObject}) {
    super()

    this._unseenSavedSearchMatchesValueObject = unseenSavedSearchMatchesValueObject
  }

  getUnseenSavedSearchMatches = () =>
    this._unseenSavedSearchMatchesValueObject({
      unseenSavedSearchMatches: {counter: 0}
    })
}

export default EmptyUserAlertsRepository
